import { ADDITIONAL_LAYER_TYPES, ADDITIONAL_LAYERTREE_CODES, alternativeLandCodes, baseLayerCodes, LAND_CATEGORIES, landCategoryUrlParams, legacyLandCodes, multiLandLayers, SEASON_CODES, summerLandLayers, winterLandCodes, winterLandLayers, } from './layerConstants.js';
import { capitalize } from '../utils.js';
export function getMultiLandCategoryKVP(land, category) {
    if (land === 'wanderland') {
        switch (category) {
            case 'national':
                return 'wanderlandetappennational';
            case 'regional':
                return 'wanderlandetappenregional';
            case 'local':
                return 'wanderlandetappenlokal';
            case 'handicap':
                return 'wanderlandetappenhandicap';
            case 'wanderwegnetz':
                return 'wanderwegnetz';
        }
    }
    else if (land === 'veloland') {
        switch (category) {
            case 'national':
                return 'velolandetappennational';
            case 'regional':
                return 'velolandetappenregional';
            case 'local':
                return 'velolandetappenlokal';
        }
    }
    else if (land === 'mtbland') {
        switch (category) {
            case 'national':
                return 'mtblandetappennational';
            case 'regional':
                return 'mtblandetappenregional';
            case 'local':
                return 'mtblandetappenlokal';
            case 'trails':
                return 'mtblandtrails';
        }
    }
    else if (land === 'skatingland') {
        switch (category) {
            case 'national':
                return 'skatinglandetappennational';
            case 'regional':
                return 'skatinglandetappenregional';
            case 'local':
                return 'skatinglandetappenlokal';
        }
    }
    else if (land === 'kanuland') {
        switch (category) {
            case 'national':
                return 'kanulandetappennational';
            case 'regional':
                return 'kanulandetappenregional';
        }
    }
    else if (land === 'crosscountry') {
        switch (category) {
            case 'local':
                return 'crosscountryetappenlokal';
            case 'crosscountrynetwork':
                return 'crosscountrynetwork';
        }
    }
    else if (land === 'snowshoe') {
        switch (category) {
            case 'local':
                return 'snowshoeetappenlokal';
            case 'snowshoenetwork':
                return 'snowshoenetwork';
        }
    }
    else if (land === 'winterhiking') {
        switch (category) {
            case 'local':
                return 'winterhikingetappenlokal';
            case 'winterhikingnetwork':
                return 'winterhikingnetwork';
        }
    }
    return undefined;
}
export function isRouteLayer(layer) {
    layer = layer;
    return !!(layer.landCode && layer.layer && layer.legacyLandCode);
}
export function seasonFromLandCode(landCode) {
    return isWinterLandCode(landCode) ? 'winter' : 'summer';
}
export function isWinterLandCode(code) {
    return winterLandCodes.includes(code);
}
export function isSummerLayer(layer) {
    return summerLandLayers.includes(layer);
}
export function isMultiLayer(layer) {
    return multiLandLayers.includes(layer);
}
export function isWinterLayer(layer) {
    return winterLandLayers.includes(layer);
}
export function isSeasonCode(season) {
    return SEASON_CODES.includes(season);
}
export function isBgCode(bgCode) {
    return baseLayerCodes.includes(bgCode);
}
export function isLandCategoryUrlPrams(code) {
    return landCategoryUrlParams.includes(code);
}
export function isAdditionalLayertreeCode(code) {
    return ADDITIONAL_LAYERTREE_CODES.includes(code);
}
export function isLayertreeCode(code) {
    return (isSummerLayer(code) ||
        isWinterLayer(code) ||
        isLandCategoryUrlPrams(code) ||
        isAdditionalLayertreeCode(code));
}
export function isLandLayer(code) {
    return isSummerLayer(code) || isWinterLayer(code);
}
export function isAdditionalLayerType(type) {
    return ADDITIONAL_LAYER_TYPES.includes(type);
}
export function isAlternativeLandCode(code) {
    return alternativeLandCodes.includes(code);
}
export function isLegacyUserLand(code) {
    return legacyLandCodes.includes(code);
}
export function getLowercaseLandCategories(landLayer) {
    return LAND_CATEGORIES[landLayer]
        .map((c) => {
        const code = c.toLowerCase();
        return isLandCategoryUrlPrams(code) ? code : undefined;
    })
        .filter((c) => !!c);
}
export function getLayerApiCode(code) {
    if (isMultiLayer(code)) {
        const categories = LAND_CATEGORIES[code];
        return categories.join(',');
    }
    return capitalize(code);
}
export function getLayerTreeCodes(codes) {
    return codes
        .map((c) => {
        const lowercaseCode = c.toLowerCase();
        return lowercaseCode;
    })
        .filter((c) => isLayertreeCode(c));
}
export const apiCodeToLandCode = {
    wanderland: 'hike',
    veloland: 'cycle',
    mtbland: 'mountainbike',
    skatingland: 'skate',
    kanuland: 'canoe',
    winterhiking: 'winterhike',
    snowshoe: 'snowshoe',
    crosscountry: 'crosscountry',
    sledging: 'sledge',
};
export const landCodeToApiCode = {
    hike: 'wanderland',
    cycle: 'veloland',
    mountainbike: 'mtbland',
    skate: 'skatingland',
    canoe: 'kanuland',
    winterhike: 'winterhiking',
    snowshoe: 'snowshoe',
    crosscountry: 'crosscountry',
    sledge: 'sledging',
};
export const landToLayer = {
    wander: 'wanderland',
    velo: 'veloland',
    mountainbike: 'mtbland',
    skating: 'skatingland',
    kanu: 'kanuland',
    winterhiking: 'winterhiking',
    snowshoe: 'snowshoe',
    crosscountry: 'crosscountry',
    sledging: 'sledging',
};
export const layerToLand = Object.fromEntries(Object.entries(landToLayer).map((arr) => arr.reverse()));
export const landToLandCode = {
    wander: 'hike',
    velo: 'cycle',
    mountainbike: 'mountainbike',
    skating: 'skate',
    kanu: 'canoe',
    winterhiking: 'winterhike',
    snowshoe: 'snowshoe',
    crosscountry: 'crosscountry',
    sledging: 'sledge',
};
export const layerToTourTimeCode = {
    wanderland: 'wander',
    veloland: 'velo',
    mtbland: 'mountain_biking',
    skatingland: 'skating',
    kanuland: 'canoeing',
    winterhiking: 'winter_hiking',
    snowshoe: 'snowshoe_trekking',
    crosscountry: 'cross_country_skiing',
    sledging: 'sledging',
};
export const layerToGraphHopperProfile = {
    wanderland: 'schmwander',
    veloland: 'schmvelo',
    mtbland: 'schmmtb',
    skatingland: 'schmskating',
    kanuland: 'schmcanoe',
    winterhiking: 'schmwinterhiking',
    snowshoe: 'schmsnowshoe',
    crosscountry: 'schmcrosscountry',
    sledging: 'schmsledging',
};
export const FLEXIBLE_GRAPHHOPPER_PROFILES = new Set([
    'schmwinterhiking',
    'schmsnowshoe',
    'schmsledging',
    'schmskating',
    'schmcrosscountry',
    'schmcanoe',
]);
export const tourTimeCodeToLayer = {
    wander: 'wanderland',
    velo: 'veloland',
    e_velo: 'veloland',
    mountain_biking: 'mtbland',
    e_mountain_biking: 'mtbland',
    skating: 'skatingland',
    canoeing: 'kanuland',
    winter_hiking: 'winterhiking',
    snowshoe_trekking: 'snowshoe',
    cross_country_skiing: 'crosscountry',
    sledging: 'sledging',
};
export const alternativeCodeToLandCode = {
    mountainbikeland: 'mountainbike',
    mtb: 'mountainbike',
};
export function getNetworkTargetLayers() {
    return [...summerLandLayers, ...winterLandLayers];
}
//# sourceMappingURL=layerHelpers.js.map